import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import './styles.css';
import { App } from './App';
import { primeUiFontScale, UiPreferencesProvider } from './lib/uiPreferences';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 5_000, refetchOnWindowFocus: false, retry: 1 },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('#root element not found in index.html');

primeUiFontScale();

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <UiPreferencesProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </UiPreferencesProvider>
  </React.StrictMode>,
);
